import clsx from "clsx";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export type RowGap = "none" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

export interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?: RowGap;
  centered?: boolean;
}

const Row = forwardRef<HTMLDivElement, RowProps>((props, ref) => {
  const { className, gap = "md", centered = false, ...rest } = props;
  return (
    <div
      {...rest}
      ref={ref}
      className={twMerge(
        clsx("flex flex-row", {
          "gap-8": gap === "2xl",
          "gap-6": gap === "xl",
          "gap-4": gap === "lg",
          "gap-3": gap === "md",
          "gap-2": gap === "sm",
          "gap-1": gap === "xs",
          "items-center": centered,
        }),
        className
      )}
    />
  );
});

export default Row;
